import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from "@angular/common/http";
import {Observable} from "rxjs";
import {devFirmware} from "../interfaces/dev-firmware.interface";
import {environment} from "../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class DevFirmwareService {

  constructor(private http:HttpClient) { }

  index(
		filters: any, orderBy = '', order = 'asc',
		pageNumber = 0, pageSize = 5): Observable<any> {
		let params = new HttpParams();
		Object.keys(filters).forEach(function (key) {
			params = params.append(key, filters[key]);
		});
		params = params.append('order_by', orderBy);
		params = params.append('order', order);
		params = params.append('page', pageNumber);
		params = params.append('per_page', pageSize);
		return this.http.get(environment.apiUrl + '/dev-firmwares', {
			params: params
		});
	}

	storeOrUpdate(devFirmwares: devFirmware): Observable<Object> {
		return devFirmwares.id ? this.edit(devFirmwares) : this.store(devFirmwares);
	}

	store(devFirmware: any): Observable<Object> {
		let formData = new FormData();

		if(devFirmware.zip_file){
			formData.append('zip_file', devFirmware.zip_file, devFirmware.zip_file.name);
		}
		for(let key in devFirmware){
			formData.append(key, devFirmware[key]);
		}
		return this.http.post(environment.apiUrl + '/dev-firmwares', formData);
	}

	edit(devFirmware: any): Observable<Object> {
		let formData = new FormData();
		if(devFirmware.zip_file){
			formData.append('zip_file', devFirmware.zip_file, devFirmware.zip_file.name);
		}
		for(let key in devFirmware){
			formData.append(key, devFirmware[key]);
		}
		formData.append('_method', 'PUT');
		return this.http.post(environment.apiUrl + '/dev-firmwares/' + devFirmware.id, formData);
	}
	destroy(id: number): Observable<Object> {
		return this.http.delete(environment.apiUrl + '/dev-firmwares/' + id);
	}

	bulkDelete(ids: number[]): Observable<Object> {
		return this.http.patch(environment.apiUrl + '/dev-firmwares/delete-multiple', {
			ids
		});
	}
}
